import React from "react";
import Select from "react-select";

const baseStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#fff",
    borderColor: state.selectProps.isInvalid ? "#dc3545" : "#ced4da",
    padding: "8px 4px",
    borderRadius: "3px",
    boxShadow: "none",
    "&:hover": {
      borderColor: state.selectProps.isInvalid ? "#dc3545" : "#ced4da",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "#000" ,
    fontStyle: "italic",
    textTransform: "uppercase",
    fontSize: "11px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#000",
    fontStyle: "italic",
    textWrap: "nowrap",
    textTransform: "uppercase",
    fontSize: "11px",
  }),
  input: (base) => ({
    ...base,
    color: "#000",
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#fff",
    zIndex: 20,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled
      ? "#fff"
      : state.isFocused
      ? "#946D42"
      : "##fff",
    color: state.isDisabled ? "#ced4da" : "#282828",
    fontStyle: "italic",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#946D42",
  }),
};

/**
 * Plain (non-formik) react-select wrapper.
 * Emits onChange with a native-select-like event shape: { target: { name, value } }
 *
 * Optional `styleOverrides` prop: an object of the same shape as react-select's
 * `styles`, merged on top of the default dark theme per-key. Pass this only
 * when a specific usage needs different sizing/colors — omit it everywhere
 * else to keep existing behavior unchanged.
 */
const SelectInput = ({
  name,
  options,
  value,
  onChange,
  placeholder,
  isDisabled,
  isInvalid,
  styleOverrides,
  ...rest
}) => {
  const selectedOption =
    options.find((opt) => String(opt.value) === String(value)) || null;

  const mergedStyles = styleOverrides
    ? Object.keys(baseStyles).reduce((acc, key) => {
        acc[key] = (base, state) => {
          const withBase = baseStyles[key](base, state);
          return styleOverrides[key]
            ? styleOverrides[key](withBase, state)
            : withBase;
        };
        return acc;
      }, {})
    : baseStyles;

  return (
    <Select
      name={name}
      options={options}
      placeholder={placeholder}
      value={selectedOption}
      onChange={(selected) =>
        onChange({
          target: {
            name,
            value: selected ? selected.value : "",
          },
        })
      }
      isOptionDisabled={(option) => !!option.disabled}
      styles={mergedStyles}
      isInvalid={isInvalid}
      isDisabled={isDisabled}
      classNamePrefix="rs"
      {...rest}
    />
  );
};

export default SelectInput;